import { styled } from '@mui/material/styles';
import { Box, Paper } from '@mui/material';

export const CalculatedRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
}));

export const FieldPickerContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: theme.spacing(2),
  maxHeight: 250,
  overflow: 'auto',
}));

export const FieldPickerColumn = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  maxHeight: 250,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  border: `1px solid ${theme.palette.divider}`,
}));

export const OperatorBar = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(0.5),
  flexWrap: 'wrap',
  padding: theme.spacing(1, 0),
}));

export const FormulaPreview = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  fontFamily: 'monospace',
  fontSize: '0.875rem',
  backgroundColor: theme.palette.background.default,
  border: `1px solid ${theme.palette.divider}`,
  minHeight: 60,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
}));

export const CaseWhenContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  padding: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
}));

export const ConditionRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  flexWrap: 'wrap',
}));

export const FunctionGrid = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(0.5),
  flexWrap: 'wrap',
  padding: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.default,
}));
